import Vue from "vue";
import store from "../store";
export default class Alert {
  constructor(Vue) { }
  alertConfirmFormData(config, data) {
    Vue.prototype
      .$swal({
        title: "¿Deseas " + config.action + " " + config.obj + " ?",
        text: "",
        icon: "question",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#a9a5a5",
        confirmButtonText:
          config.action.charAt(0).toUpperCase() + config.action.slice(1),
        cancelButtonText: "Regresar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await store.getters.getFirebaseApp.fba
            .callForm(config.route, config.data, {
              "Content-Type": "multipart/form-data",
            })
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              Vue.prototype.$swal.showValidationMessage(
                `Request failed: ${error}`
              );
            });
        },
      })
      .then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            Vue.prototype
              .$swal({
                title: "Éxito",
                text: "La operación se realizó correctamente",
                icon: "success",
              })
              .then(async () => {
                config.onSuccess(result.value);
              });
          } else {
            Vue.prototype.$swal(
              "Error " + config.obj,
              result.value.data.error,
              "error"
            );
          }
        }
      });
  }
  alertConfirm(config, data) {
    Vue.prototype
      .$swal({
        title: "¿Deseas " + config.action + " " + config.obj + " ?",
        text: "",
        icon: "question",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#a9a5a5",
        confirmButtonText:
          config.action.charAt(0).toUpperCase() + config.action.slice(1),
        cancelButtonText: "Regresar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await store.getters.getFirebaseApp.fba
            .call(config.route, config.data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              Vue.prototype.$swal.showValidationMessage(
                `Request failed: ${error}`
              );
            });
        },
      })
      .then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            Vue.prototype
              .$swal({
                title: "Éxito",
                text: "La operación se realizó correctamente",
                icon: "success",
              })
              .then(async () => {
                config.onSuccess(result.value);
              });
          } else {
            Vue.prototype.$swal(
              "Error " + config.obj,
              result.value.data.error,
              "error"
            );
          }
        }
      });
  }

  alert(config) {
    Vue.prototype.$swal({
      title: config.title,
      text: config.subtitle,
      icon: config.icon,
    });
  }

  alertConfirmAll(config, data) {
    return Vue.prototype
      .$swal({
        title: "¿Deseas " + config.action + " " + config.obj + "?",
        icon: "question",
        text: config.text ? config.text : "",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#a9a5a5",
        confirmButtonText:
          config.action.charAt(0).toUpperCase() + config.action.slice(1),
        cancelButtonText: "Regresar",
        showLoaderOnConfirm: true,

        preConfirm: async () => {
          // Utilizamos Promise.allSettled para esperar todas las respuestas
          const results = await Promise.allSettled(
            data.map((d) =>
              store.getters.getFirebaseApp.fba.call(config.route, d)
            )
          );
          return results;
        },
      })
      .then((result) => {
        if (!result.value) return;

        // Separamos las respuestas según el status que retorna
        const fulfilled = result.value.filter((r) => r.status === "fulfilled");
        const rejected = result.value.filter((r) => r.status === "rejected");

        // En las respuestas fulfilled, checamos si data ta ok
        const fulfilledOk = fulfilled.filter(
          (r) => r.value && r.value.data && r.value.data.ok
        );
        const fulfilledWithError = fulfilled.filter(
          (r) => !(r.value && r.value.data && r.value.data.ok)
        );

        // Contadores finales
        const successCount = fulfilledOk.length;
        const failedCount = rejected.length + fulfilledWithError.length;

        // Invocar el callback onSuccess pasando la información necesaria
        config.onSuccess({
          successCalls: fulfilledOk,
          failedCalls: [...rejected, ...fulfilledWithError],
          successCount,
          failedCount,
          allResults: result.value,
        });
      });
  }

  alertConfirmAllSequential(config, data) {
    return Vue.prototype
      .$swal({
        title: "¿Deseas " + config.action + " " + config.obj + "?",
        icon: "question",
        text: config.text ? config.text : "",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#a9a5a5",
        confirmButtonText:
          config.action.charAt(0).toUpperCase() + config.action.slice(1),
        cancelButtonText: "Regresar",
        showLoaderOnConfirm: true,

        preConfirm: async () => {
          const results = [];
          for (const payload of data) {
            try {
              const value = await store.getters.getFirebaseApp.fba.call(
                config.route,
                payload,
              );
              results.push({ status: "fulfilled", value });
            } catch (error) {
              results.push({ status: "rejected", reason: error });
            }
          }
          return results;
        },
      })
      .then((result) => {
        if (!result.value) return;

        const fulfilled = result.value.filter((r) => r.status === "fulfilled");
        const rejected = result.value.filter((r) => r.status === "rejected");

        const fulfilledOk = fulfilled.filter(
          (r) => r.value && r.value.data && r.value.data.ok,
        );
        const fulfilledWithError = fulfilled.filter(
          (r) => !(r.value && r.value.data && r.value.data.ok),
        );

        const successCount = fulfilledOk.length;
        const failedCount = rejected.length + fulfilledWithError.length;

        config.onSuccess({
          successCalls: fulfilledOk,
          failedCalls: [...rejected, ...fulfilledWithError],
          successCount,
          failedCount,
          allResults: result.value,
        });
      });
  }
}
